module.exports = __webpack_public_path__ + "img/icon_dianti_02.8f2c505b.png";